import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SeoMeta from "../components/SeoMeta";
import { SiteNav } from "../components/home/SiteNav";
import { Hero, Intro, OwnThem, Panels, WhatsOn, Island, WhyFeral, Pause, Gallery } from "../components/home/Reskin";
import { SiteFooter } from "../components/home/BreathworkAndFooter";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 400);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <div className="bg-[#f2e5de]" data-testid="home-page">
      <SeoMeta
        title="FERAL Collective | Retreats, events and stays on Anglesey, North Wales"
        description="Be Free, Be FERAL. A collective rooted in nature, wellness and community with three historic estates on the wild edges of Anglesey."
        canonicalPath="/"
        image="/skin/hero.webp"
        jsonLd={{ "@context": "https://schema.org", "@type": "Organization", name: "FERAL Collective", url: "https://feralcollective.co.uk/", slogan: "Be Free, Be FERAL." }}
      />
      <SiteNav />
      <Hero />
      <Intro />
      <OwnThem />
      <Panels />
      <WhatsOn />
      <Island />
      <WhyFeral />
      <Pause />
      <Gallery />
      <SiteFooter />
    </div>
  );
};

export default Home;
